import React, { useEffect, useMemo, useState } from "react";
import Combobox from "./Combobox";

export default function ClienteSection({
  clientes,
  cliente,
  setCliente,
  selectedCliente,
  atencion,
  setAtencion,
  clienteEmail,
  setClienteEmail,
  clienteTelefono,
  setClienteTelefono,
  markDirty,
  clienteOpen,
  setClienteOpen,
  clienteAnchorRef,
  clientePanelRef,
  clientePos,
  invalidFields = {},
}) {
  const [query, setQuery] = useState("");

  useEffect(() => {
    const label = selectedCliente?.empresa || selectedCliente?.nombre || "";
    setQuery(label);
  }, [selectedCliente]);

  const items = useMemo(
    () => (Array.isArray(clientes) ? clientes : []),
    [clientes],
  );

  return (
    <div className="cf-grid cf-grid-2">
      <Combobox
        className="cf-combobox--clientes"
        inputClassName={invalidFields?.razonSocial ? "cf-invalid" : ""}
        label="Razón Social"
        required
        placeholder="Buscar o escribir empresa..."
        value={query}
        onChange={(v) => setQuery(v)}
        open={clienteOpen}
        setOpen={setClienteOpen}
        anchorRef={clienteAnchorRef}
        panelRef={clientePanelRef}
        pos={clientePos}
        items={items}
        ariaLabel="Clientes"
        filterFn={(c) => {
          const q = (query || "").toLowerCase().trim();
          if (!q) return true;

          const empresa = (c?.empresa || c?.nombre || "").toLowerCase();
          const persona = (
            c?.contacto ||
            c?.atencion ||
            c?.persona ||
            ""
          ).toLowerCase();
          const rfc = (c?.rfc || c?.RFC || "").toLowerCase();

          return empresa.includes(q) || persona.includes(q) || rfc.includes(q);
        }}
        getKey={(c) => c.id}
        renderItem={(c) => {
          const empresa = c?.empresa || c?.nombre || "Sin nombre";
          const persona = (
            c?.contacto ||
            c?.atencion ||
            c?.persona ||
            c?.nombreContacto ||
            c?.contact_name ||
            c?.representante ||
            c?.encargado ||
            ""
          ).toLowerCase();
          const rfc = c?.rfc || c?.RFC || "";

          const isSelected = cliente === c.id;

          return (
            <div
              className={`cf-client-item ${isSelected ? "is-selected" : ""}`}
            >
              <div className="cf-client-text">
                <div className="cf-client-title">{empresa}</div>
                {persona || rfc ? (
                  <div className="cf-client-meta">
                    {persona ? <span>{persona}</span> : null}
                    {persona && rfc ? (
                      <span className="cf-client-dot">•</span>
                    ) : null}
                    {rfc ? <span>{rfc}</span> : null}
                  </div>
                ) : null}
              </div>
            </div>
          );
        }}
        onSelect={(c) => {
          const empresa = c?.empresa || c?.nombre || "";
          setCliente?.(c.id);
          setQuery(empresa);
          setClienteOpen(false);
          markDirty?.();
        }}
      />

      <div className="cf-field">
        <label className="cf-label">Atención</label>
        <input
          className="cf-input"
          value={atencion || ""}
          onChange={(e) => {
            setAtencion?.(e.target.value);
            markDirty?.();
          }}
          placeholder="Juan Pérez"
        />
      </div>

      <div className="cf-field">
        <label className="cf-label">Email</label>
        <input
          className="cf-input"
          value={clienteEmail || ""}
          onChange={(e) => {
            setClienteEmail?.(e.target.value);
            markDirty?.();
          }}
          placeholder="cliente@empresa.com"
        />
      </div>

      <div className="cf-field">
        <label className="cf-label">Teléfono</label>
        <input
          className="cf-input"
          value={clienteTelefono || ""}
          onChange={(e) => {
            setClienteTelefono?.(e.target.value);
            markDirty?.();
          }}
          placeholder="+52 55 1234 5678"
        />
      </div>
    </div>
  );
}
